
jQuery(document).ready(function($) {
  $(document).foundation();
  
  
	// active menu
	$('ul li a').click(function(){
		$('li a').removeClass("active");
		$(this).addClass("active");
	});

	// testimonial slider
	$('.testimonial_slider').slick({
		dots: true,
		infinite: true,
		speed: 300,
		slidesToShow: 4,
		slidesToScroll: 1,
		dots: false,
		prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
		nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
		responsive: [
		{
			breakpoint: 1201,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 1

			}
		},
		{
			breakpoint: 768,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 2
			}
		},
		{
			breakpoint: 501,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			}
		}
		// You can unslick at a given breakpoint now by adding:
		// settings: "unslick"
		// instead of a settings object
		]
	});

	// banner slider
	$('.sliderBanner').slick({
		infinite: true,
		prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
		nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></button>'
	});

	// down scroll
	$(".bottom_arrow a i").click(function() {
		$('html,body').animate({
			scrollTop: $(".services").offset().top},
			1000);
	});


});


// (function($){
  // $=jQuery;
  // $(document).foundation();
// your standard jquery code goes here with $ prefix
// best used inside a page with inline code, 
// or outside the document ready, enter code here
  // $('.banner .more_contact a').click(function(event) {
  //  /* Act on the event */
  //  event.preventDefault();
  //  $('.banner .more_contact a').css("background: #fff","color: #000");
  // });
// });
jQuery(document).foundation();
/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {

    // Remove empty P tags created by WP inside of Accordion and Orbit
    jQuery('.accordion p:empty, .orbit p:empty').remove();

	 // Makes sure last grid item floats left
	jQuery('.archive-grid .columns').last().addClass( 'end' );

	// Adds Flex Video to YouTube and Vimeo Embeds
  jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
    if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
      jQuery(this).wrap("<div class='widescreen flex-video'/>");
    } else {
      jQuery(this).wrap("<div class='flex-video'/>");
    }
  });

});




